// PublicView.js (Ahora actúa como la página del proyecto)
import React, { useState, useEffect } from 'react';
import './Proyectos.css'; 
// Asumiendo que PeajesPage está en una carpeta hermana a la de Proyectos/PublicView
import PeajesPage from '../PeajesPage/PeajesPage'; 

const PublicView = ({ isAdmin, onEdit, onCreateNew }) => {
  const [proyecto, setProyecto] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Estado para cada carrusel
  const [slideTemaInteres, setSlideTemaInteres] = useState(0);
  const [slideGaleria, setSlideGaleria] = useState(0);

  // Estado para controlar la visibilidad de la barra de admin
  const [isAdminBarOpen, setIsAdminBarOpen] = useState(false);

  const fetchProyecto = async () => {
    setIsLoading(true);
    try {
      const response = await fetch('https://api.interventorsisgafr.com/api/reportes');
      if (!response.ok) throw new Error('No se pudo conectar con el servidor.');
      const data = await response.json();
      setProyecto(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProyecto();
  }, []);

  const handleDelete = async () => {
    if (window.confirm('¿Estás seguro de que quieres eliminar esta publicación? Esta acción no se puede deshacer.')) {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`https://api.interventorsisgafr.com/api/reportes/${proyecto.id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('No se pudo eliminar el reporte.');
            alert('Publicación eliminada.');
            setProyecto(null);
        } catch (err) {
            setError(err.message);
        }
    }
  };

  if (isLoading) return <p className="mensaje-carga">Cargando proyecto...</p>;
  if (error) return <p className="mensaje-error">Error: {error}</p>;

  if (!proyecto) {
    return (
      <div className="proyecto-vacio">
        <h2>No hay ningún proyecto publicado.</h2>
        {isAdmin && (
          <button onClick={onCreateNew} className="create-new-button-grande">
            + Crear Primera Publicación
          </button>
        )}
      </div>
    );
  }

  const { data, imagen_principal_url } = proyecto;
  const API_URL = 'https://api.interventorsisgafr.com/';

  return (
    <div className="proyecto-vista-container">
        
        {isAdmin && (
            <div className="proyecto-admin-controls">
                <button 
                    className="admin-toggle-btn" 
                    onClick={() => setIsAdminBarOpen(!isAdminBarOpen)}
                    aria-label="Toggle admin controls"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                </button>
                <div className={`proyecto-admin-bar ${isAdminBarOpen ? 'open' : ''}`}>
                    <span>Modo Avanzado</span>
                    <button onClick={() => onEdit(proyecto)} className="admin-button">Editar Publicación</button>
                    <button onClick={handleDelete} className="admin-button delete">Eliminar Publicación</button>
                </div>
            </div>
        )}
        
      <header 
        className="proyecto-header" 
        style={{ backgroundImage: `url(${API_URL}${imagen_principal_url})` }}
      >
        <div className="header-overlay"></div>
        <div className="header-content">
            <div className="proyecto-label">PROYECTO</div>
            <h1>{data.titulo}</h1>
        </div>
      </header>

      <main className="proyecto-body">
        <div className="presentacion-grid">
            <div className="presentacion-texto">
                <h2>PRESENTACIÓN DEL PROYECTO</h2>
                <p>{data.resumen}</p>
                <p>{data.descripcion?.parrafo1}</p>
                <p>{data.descripcion?.parrafo2}</p>
                
                {data.descripcion?.imagen3_url && <img src={`${API_URL}${data.descripcion.imagen3_url}`} alt="Evidencia del proyecto 3" className="imagen-parrafo" />}
                
                <p>{data.descripcion?.parrafo3}</p>
                
                {data.descripcion?.imagen4_url && <img src={`${API_URL}${data.descripcion.imagen4_url}`} alt="Evidencia del proyecto 4" className="imagen-parrafo" />}

                <p>{data.descripcion?.parrafo4}</p>
            </div>
            <div className="info-box">
                <div className="info-item">
                    <span className="info-icon">🏢</span>
                    <div className="info-text">
                        <strong>Cliente</strong>
                        <span>Agencia Nacional de Infraestructura</span>
                    </div>
                </div>
                <div className="info-item">
                     <span className="info-icon">📍</span>
                    <div className="info-text">
                        <strong>Ubicación</strong>
                        <span>Cundinamarca, Boyacá, Casanare</span>
                    </div>
                </div>
                <div className="info-item">
                     <span className="info-icon">💰</span>
                    <div className="info-text">
                        <strong>Inversión</strong>
                        <span>{data.cifras?.inversion}</span>
                    </div>
                </div>
                <div className="info-item">
                     <span className="info-icon">📅</span>
                    <div className="info-text">
                        <strong>Periodo</strong>
                        <span>{data.cifras?.duracion}</span>
                    </div>
                </div>
                <div className="info-item">
                     <span className="info-icon">↔️</span>
                    <div className="info-text">
                        <strong>Longitud</strong>
                        <span>{data.cifras?.longitud}</span>
                    </div>
                </div>
                <div className="info-item">
                     <span className="info-icon">🚗</span>
                    <div className="info-text">
                        <strong>Tráfico Promedio</strong>
                        <span>{data.cifras?.tpd}</span>
                    </div>
                </div>
                <div className="info-links-container">
                    <a 
                        href="https://community.secop.gov.co/Public/Tendering/OpportunityDetail/Index?noticeUID=CO1.NTC.7915096&isFromPublicArea=True&isModal=False" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="info-link-btn"
                    >
                        Documento contractual
                    </a>
                    <a 
                        href="https://aniscopio.ani.gov.co/reportes/carreteros/proyectoDetalle/25" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="info-link-btn"
                    >
                        Portal aniscopio proyecto SISGA
                    </a>
                </div>
            </div>
        </div>
      </main>

      <PeajesPage />

      {/* === NUEVA SECCIÓN: TEMA DE INTERÉS === */}
      {data.tema_interes_urls && data.tema_interes_urls.length > 0 && (
        <section className="galeria-seccion">
            <div className="galeria-contenido">
                <div className="galeria-titulo">
                    <h2>TEMA DE INTERÉS</h2>
                </div>
                <div className="carrusel-container">
                    <button 
                        onClick={() => setSlideTemaInteres(slideTemaInteres === 0 ? data.tema_interes_urls.length - 1 : slideTemaInteres - 1)} 
                        className="carrusel-boton prev"
                    >
                        &#10094;
                    </button>
                    <div className="carrusel-slides" style={{ transform: `translateX(-${slideTemaInteres * 100}%)` }}>
                        {data.tema_interes_urls.map((imgUrl, index) => (
                          <div className="carrusel-slide" key={index}>
                            <img src={`${API_URL}${imgUrl}`} alt={`Tema de interés ${index + 1}`} />
                          </div>
                        ))}
                    </div>
                    <button 
                        onClick={() => setSlideTemaInteres(slideTemaInteres === data.tema_interes_urls.length - 1 ? 0 : slideTemaInteres + 1)}
                        className="carrusel-boton next"
                    >
                        &#10095;
                    </button>
                    <div className="carrusel-dots">
                        {data.tema_interes_urls.map((_, index) => (
                            <span 
                                key={index} 
                                className={`carrusel-dot ${slideTemaInteres === index ? 'active' : ''}`}
                                onClick={() => setSlideTemaInteres(index)}
                            ></span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
      )}

      {/* SECCIÓN DE GALERÍA DE IMÁGENES */}
      {data.galeria_urls && data.galeria_urls.length > 0 && (
        <section className="galeria-seccion">
            <div className="galeria-contenido">
                <div className="galeria-titulo">
                    <h2>GALERÍA DE IMÁGENES</h2>
                </div>
                <div className="carrusel-container">
                    <button 
                        onClick={() => setSlideGaleria(slideGaleria === 0 ? data.galeria_urls.length - 1 : slideGaleria - 1)} 
                        className="carrusel-boton prev"
                    >
                        &#10094;
                    </button>
                    <div className="carrusel-slides" style={{ transform: `translateX(-${slideGaleria * 100}%)` }}>
                        {data.galeria_urls.map((imgUrl, index) => (
                          <div className="carrusel-slide" key={index}>
                            <img src={`${API_URL}${imgUrl}`} alt={`Evidencia del proyecto ${index + 1}`} />
                          </div>
                        ))}
                    </div>
                    <button 
                        onClick={() => setSlideGaleria(slideGaleria === data.galeria_urls.length - 1 ? 0 : slideGaleria + 1)} 
                        className="carrusel-boton next"
                    >
                        &#10095;
                    </button>
                    <div className="carrusel-dots">
                        {data.galeria_urls.map((_, index) => (
                            <span 
                                key={index} 
                                className={`carrusel-dot ${slideGaleria === index ? 'active' : ''}`}
                                onClick={() => setSlideGaleria(index)}
                            ></span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
      )}
    </div>
  );
};

export default PublicView;